import { concat } from '@ember/helper';
import { htmlSafe } from '@ember/template';
import { t } from 'ember-intl';
import BvInline from 'volta/components/bv-inline';
import BvMethodoIcon from 'volta/components/bv-methodo-icon';
import BvTag from 'volta/components/bv-tag';
import CodeDesc from 'volta/components/code-desc';
import classNames from 'volta/helpers/class-names';

import type { TOC } from '@ember/component/template-only';
import type SearchEntry from 'volta/models/search-entry';
import type { PayloadSku } from 'volta/models/search-entry';

interface BvAppSearchEntrySkuSignature {
  Args: {
    entry: SearchEntry<PayloadSku>;
  };
  Element: HTMLElement;
}

const BvAppSearchEntrySkuComponent: TOC<BvAppSearchEntrySkuSignature> = <template>
  <BvInline @gap='2' @wrap={{false}} class='u-overflow-hidden' ...attributes>
    <BvMethodoIcon
      @methodology={{@entry.payload.methodology}}
      @isProtected={{@entry.payload.isProtected}}
      @reorderStrategy={{@entry.payload.reorderStrategy}}
    />
    <CodeDesc
      @code={{htmlSafe @entry.payload.partCode}}
      @desc={{if @entry.payload.description (htmlSafe @entry.payload.description)}}
      @fontVariant='body-sm'
      class={{classNames
        'u-flex-1 u-ellipsis'
        (unless @entry.payload.isActive 'u-text-strike u-color-text-disabled')
      }}
    />
    <BvTag
      @size='sm'
      @text={{t (concat 'acqCodes.' @entry.payload.acqCode)}}
      @tooltip={{t 'acqCode'}}
    />
    <BvTag
      @size='sm'
      @text={{@entry.payload.warehouseCode}}
      @color='green'
      @tooltip={{t 'warehouse'}}
    />
  </BvInline>
</template>;

export default BvAppSearchEntrySkuComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::Sku': typeof BvAppSearchEntrySkuComponent;
    'bv-app-search/entry/sku': typeof BvAppSearchEntrySkuComponent;
  }
}
